import React from 'react';
import PropTypes from 'prop-types';
import styles from './SimpleProfile.module.css';

const SimpleProfile = ({ user, onClick, isActive }) => {
  return (
    <button
      className={`${styles.profileTrigger} ${isActive ? styles.active : ''}`}
      onClick={onClick}
    >
      <div className={styles.profileAvatar}>
        {user.image ? (
          <img src={user.image} alt={user.name} />
        ) : (
          <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 10a4 4 0 100-8 4 4 0 000 8zm0 2c-4.418 0-8 1.79-8 4v2h16v-2c0-2.21-3.582-4-8-4z" />
          </svg>
        )}
      </div>
      <span className={styles.profileName}>
        {user.firstName} {user.lastName}
      </span>
      <span className={styles.dropdownIcon}>▼</span>
    </button>
  );
};

SimpleProfile.propTypes = {
  user: PropTypes.object,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
};

export default SimpleProfile;
